<!--
 * @Descripttion: KVKK隐私协议页面
 * @version:
 * @Author:
 * @Date: 2024-01-01
 * @LastEditors:
 * @LastEditTime:
 * @FilePath: \wanguo_web\src\views\privacy\kvkk.vue
-->
<template>
  <div class="kvkk-container">
    <div class="kvkk-content">
        <h1 class="kvkk-title">KVKK Aydınlatma Metni</h1>

        <div class="kvkk-section">
          <p><strong>Sayın Müşterimiz,</strong></p>

          <p>Türkiye OKEY eğlence makinesine gösterdiğiniz ilgi, işbirliği ve satın alma tercihiniz için içten
          teşekkürlerimizi sunar; ayrıca bu resmi uygulamayı (APP) indirip kullandığınız için de şükranlarımızı
          belirtmek isteriz. Türkiye Cumhuriyeti yasalarına sıkı sıkıya bağlı kalarak, kişisel verilerinizin güvenliği
          ve yasal haklarınızın eksiksiz şekilde korunmasını teminen, 6698 sayılı Kişisel Verilerin Korunması Kanunu
          (KVKK)'nun 10. maddesi ve ilgili ikincil mevzuat hükümleri uyarınca, uygulamaya kayıt işleminizi tamamlamadan
          önce, kişisel verilerinizin toplanması, kullanılması, saklanması ve korunmasına ilişkin temel hususlar
          hakkında sizi resmi, eksiksiz ve aşağıdaki şekilde bilgilendiriyoruz. Lütfen bu metni dikkatlice okuyunuz ve
          tam olarak anlayınız:</p>
        </div>



        <div class="kvkk-section">
          <h2>1. Kişisel Verilerin Toplanma Kapsamı ve Yöntemi</h2>
         <ol>
            <li>1. Toplama Kapsamı: Uygulamanın normal işleyişi, iş
            ilişkilerinin kurulması ve hizmet taahhütlerinin yerine getirilmesi amacıyla, yalnızca gerekli olan kişisel
            verileriniz toplanacaktır. Bunlar; kimlik bilgilerinizle uyumlu adınız-soyadınız, geçerli iletişim
            bilgileriniz (cep telefonu numarası/elektronik posta adresi) ve uygulama kayıt hesabına ilişkin temel
            bilgilerinizdir. Din, sağlık, finansal hesap öz bilgileri gibi hizmetle ilgisi bulunmayan hassas kişisel
            verileriniz aktif olarak talep edilmez ve toplanmaz. Hiçbir şekilde aşırı veri toplama işlemi
            gerçekleştirilmemektedir.</li>
            <li> 2. Toplama Yöntemi: Verileriniz, yalnızca sizin uygulamanın kayıt arayüzünde gönüllü, açık rızanıza
            dayalı ve bilgilendirilmiş olarak doldurup göndermeniz yoluyla elde edilecektir. Verilerinize gizli yollarla
            veya üçüncü taraflar kanalıyla hukuka aykırı şekilde erişilmez ve toplanmaz.</li>

          </ol>
          </div>

        <div class="kvkk-section">
          <h2>2. Kişisel Verilerin Kullanım Amacı ve Sınırları</h2>

          <ol>
            <li>1. Temel Kullanım Amaçları: ① Size uygulama hesabı oluşturma, giriş yapma ve normal işlevleri kullanma
            gibi temel hizmetleri sağlamak; ② OKEY eğlence makinesi ürün danışmanlığı, sipariş yerine getirme, satış
            sonrası bakım-onarım, teknik destek gibi ilgili iş süreçlerini yürütmek; ③ KVKK ve Türk mevzuatı
            gerekliliklerine uygun olarak kişisel verileri muhafaza etmek ve iş sürekliliğini yasal çerçevede sağlamak;
            ④ Uygulama hizmet deneyimini iyileştirmek amacıyla, yalnızca anonim hale getirilmiş ve kimliklendirici
            niteliği kaldırılmış veriler üzerinden kullanım alışkanlıklarına ilişkin istatistik oluşturmak (bu
            istatistikler hiçbir şekilde spesifik bir kişiyle ilişkilendirilmez).</li>
            <li>2. Kullanım Sınırları: Kanunlarda açıkça öngörülen haller dışında, kişisel verileriniz açık rızanız
            (yazılı veya elektronik onay) olmaksızın hiçbir üçüncü tarafa devredilmez, kiralanmaz veya paylaşılmaz.
            Verileriniz, size bu belgede bildirilen amaçlar dışında başka bir maksatla kullanılmaz. Kullanım amacının
            genişletilmesi durumunda, size ayrıca açık rıza talep edilecektir.</li>
          </ol>
        </div>

        <div class="kvkk-section">
          <h2>3. Kişisel Verilerin Saklanması ve Güvenlik Koruma Önlemleri</h2>
          <ol>
            <li> 1. Saklama İlkeleri: Kişisel verileriniz, KVKK güvenlik standartlarına
            uygun sunucularda saklanacaktır. Saklama süresi, "gerekli olan en kısa süre" ilkesine sıkı sıkıya bağlı
            kalınarak belirlenir. Hizmet ilişkisinin sona ermesi, hesabınızın silinmesi veya yasal saklama sürelerinin
            dolması durumunda, kişisel verileriniz zamanında güvenli bir şekilde silinecek veya anonim hale
            getirilecektir. Verileriniz uzun süreli ve sebepsiz olarak muhafaza edilmez.</li>
            <li> 2. Güvenlik Tedbirleri: Kişisel veri güvenliği yönetim sistemi
            oluşturulmuş, profesyonel güvenlik teknolojileri ekibi görevlendirilmiş ve veri şifreleme, erişim yetki
            kontrolleri, güvenlik denetimleri, virüs koruması gibi çoklu teknik ve idari önlemler alınmıştır. Bilgi
            sızıntısı, bozulma, kayıp veya kötüye kullanım risklerine karşı etkin bir acil müdahale mekanizması kurulmuş
            olup, kişisel verilerinizin korunmasına yönelik tüm sorumluluklarımızı titizlikle yerine getirmekteyiz.</li>
            </ol>
        </div>

        <div class="kvkk-section">
          <h2>4. Kanuni Haklarınız ve Kullanım Yolları</h2>
          <p>KVKK hükümleri uyarınca, kişisel verilerinizle ilgili aşağıdaki haklara sahipsiniz. Haklarınızı kullanmanızda
          size tam işbirliği sağlayacağız:</p>
          <ul>
            <li>1. Bilgi Edinme Hakkı: Uygulamada saklanan kişisel verilerinize ve bu verilerin kullanımına/saklanmasına
            ilişkin durumu her zaman sorgulama hakkı.</li>
            <li>2. Düzeltme Hakkı: Kişisel verilerinizde hata veya eksiklik olması halinde, geçerli belgelerle birlikte
            düzeltme talep etme hakkı.</li>
            <li>3. Silinmesini İsteme Hakkı: Kanunlarda ve iş gerekliliklerinde öngörülen şartların oluşması halinde,
            kişisel verilerinizin silinmesini talep etme hakkı.</li>
            <li>4. Hesabı Sildirme Hakkı: Uygulamanın resmi müşteri hizmetleri kanalları aracılığıyla hesabınızı her zaman
            silme talebinde bulunma hakkı. Hesap silindikten sonra ilgili veri temizleme işlemleri usulüne uygun şekilde
            gerçekleştirilecektir.</li>
            <li>5. İtiraz/Şikayet Hakkı: Kişisel verilerinizin kanuna aykırı olarak işlendiğini düşünmeniz halinde, bize
            itiraz etme veya Kişisel Verileri Koruma Kurumu (KVKK)'na başvurma hakkı.</li>
            <li>6. Hakların Kullanım Yolu: Yukarıdaki haklarınıza ilişkin taleplerinizi, uygulama içindeki "Müşteri
            Hizmetleri" modülü veya şirketimizin Türkiye'deki resmi iletişim telefonu/elektronik posta adresi
            aracılığıyla iletebilirsiniz. Talebiniz, KVKK'da öngörülen yasal süreler içinde incelenerek
            sonuçlandırılacak ve size bildirilecektir.</li>
          </ul>
        </div>

        <div class="kvkk-section">
          <h2>5. Diğer Önemli Açıklamalar</h2>
          <ul>
            <li>1. Bu bilgilendirme metni, KVKK ve Türkiye Cumhuriyeti ilgili mevzuatına tam uyumludur ve yasal
            geçerliliğe sahiptir. Onay vermeniz, bu metnin tüm hükümlerini kabul ettiğiniz anlamına gelir.</li>
            <li>2. Yürürlükteki mevzuat değişiklikleri nedeniyle bu metinde güncelleme yapılması gerekirse, size uygulama
            bildirimi veya resmi duyuru yoluyla zamanında bilgi verilecek ve güncellenmiş metin bildirimin size ulaştığı
            tarihten itibaren geçerli olacaktır.</li>
            <li>3. "Kabul Ediyorum" butonuna tıklamanız, bu bilgilendirme metninin tamamını okuduğunuzu, anladığınızı ve
            kişisel verilerinizin bu metinde belirtilen şekilde işlenmesini gönüllü olarak açık rızanızla onayladığınızı
            gösterir. Bu durumda uygulama kayıt sayfasına yönlendirileceksiniz. "Kabul Etmiyorum" seçeneğini tercih
            etmeniz halinde ise uygulamaya kayıt işlemini ve ilgili hizmetleri kullanma imkanını elde edemeyeceğinizi
            önemle rica ederiz.</li>
            <li>Bu bilgilendirme metni hakkında herhangi bir sorunuz, itirazınız veya kişisel verilerinize ilişkin danışma
            gereksiniminiz olması durumunda, lütfen resmi iletişim kanallarımız aracılığıyla bizimle iletişime geçmekten
            çekinmeyiniz. Size profesyonel ve detaylı açıklamalar sunmaktan memnuniyet duyacağız.</li>
            <li>
              <strong>Saygılarımızla,</strong>
            </li>
          </ul>
          </div>


    </div>
    <div v-if="isFromRegister || isRegisterSuccess" class="privacy-footer">
      <el-button v-if="isRegisterSuccess" type="primary" size="large" @click="handleSuccessConfirm">
        确认
      </el-button>
      <el-button v-else :disabled="countdown > 0 || loading" type="primary" size="large" @click="handleConfirm" :loading="loading">
        {{ countdown > 0 ? `（${countdown}秒）` : '确定' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { register } from '@/api/user';

export default {
  name: 'KvkkPrivacy',
  props: {
    // 公司全称
    companyName: {
      type: String,
      default: ''
    },
    // 公司简称
    companyShortName: {
      type: String,
      default: ''
    },
    // 公司地址
    companyAddress: {
      type: String,
      default: ''
    },
    // 公司电话
    companyPhone: {
      type: String,
      default: ''
    },
    // 公司网站
    companyWebsite: {
      type: String,
      default: ''
    },
    // 公司邮箱
    companyEmail: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      countdown: 20,
      timer: null,
      loading: false
    };
  },
  created() {
    if (this.isFromRegister) {
      this.startCountdown();
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  computed: {
    // 获取用户账号名称
    accountName() {
      const userInfo = this.$store.getters.userInfo || {};
      return userInfo.name || userInfo.realName || userInfo.account || '';
    },
    // 动态获取公司信息，优先使用props，其次使用路由参数，最后使用账号名称
    displayCompanyName() {
      return this.companyName || this.$route.query.companyName || this.accountName || '[Şirket Ünvanı]';
    },
    displayCompanyShortName() {
      return this.companyShortName || this.$route.query.companyShortName || this.accountName || '................';
    },
    displayCompanyAddress() {
      return this.companyAddress || this.$route.query.companyAddress || '';
    },
    displayCompanyPhone() {
      return this.companyPhone || this.$route.query.companyPhone || '';
    },
    displayCompanyWebsite() {
      return this.companyWebsite || this.$route.query.companyWebsite || '';
    },
    displayCompanyEmail() {
      return this.companyEmail || this.$route.query.companyEmail || '';
    },
    isFromRegister() {
      return this.$route.query.from === 'register';
    },
    isRegisterSuccess() {
      return this.$route.query.success === 'true';
    }
  },
  methods: {
    startCountdown() {
      this.countdown = 10;
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    handleConfirm() {
      const formDataStr = sessionStorage.getItem('registerFormData');
      if (!formDataStr) {
        this.$message.error('注册信息已过期，请重新填写');
        this.$router.push('/login');
        return;
      }
      this.loading = true;
      const formData = JSON.parse(formDataStr);
      register(formData).then(res => {
        this.loading = false;
        if (res.data.success) {
          sessionStorage.removeItem('registerFormData');
          this.$message.success('注册成功');
          this.$router.push({ path: '/privacy/kvkk', query: { success: 'true' } });
        } else {
          this.$message.error(res.data.msg || '注册失败');
        }
      }).catch(() => {
        this.loading = false;
      });
    },
    handleSuccessConfirm() {
      this.$router.push('/login');
    }
  }
};
</script>

<style lang="scss" scoped>
.kvkk-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100vh;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  .kvkk-content {
    background: #fff;
    padding: 40px;
    max-width: 1200px;
    margin: 0 auto;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    line-height: 1.8;
    color: #333;
    min-height: calc(100vh - 40px);

    .kvkk-title {
      text-align: center;
      font-size: 28px;
      font-weight: bold;
      margin-bottom: 30px;
      color: #2c3e50;
      border-bottom: 2px solid #409eff;
      padding-bottom: 15px;
    }

    .kvkk-section {
      margin-bottom: 30px;

      h2 {
        font-size: 20px;
        font-weight: bold;
        margin: 25px 0 15px 0;
        color: #409eff;
        border-left: 4px solid #409eff;
        padding-left: 10px;
      }

      p {
        margin-bottom: 12px;
        text-align: justify;
        font-size: 14px;
      }

      ul, ol {
        margin: 15px 0;
        padding-left: 30px;

        li {
          margin-bottom: 10px;
          text-align: justify;
          font-size: 14px;
        }
      }

      strong {
        color: #2c3e50;
        font-weight: 600;
      }
    }

    .kvkk-signature {
      margin-top: 40px;
      padding-top: 20px;
      border-top: 1px solid #e4e7ed;

      p {
        margin-bottom: 15px;
        font-size: 14px;
      }
    }
  }
}

.privacy-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 20px;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.1);
  text-align: center;
  z-index: 1000;

  .el-button {
    min-width: 300px;
  }
}

.kvkk-container {
  padding-bottom: 100px;
}

@media print {
  .kvkk-container {
    background-color: #fff;
    padding: 0;

    .kvkk-content {
      box-shadow: none;
      padding: 20px;
    }
  }

  .privacy-footer {
    display: none;
  }
}
</style>

